import { useContext } from 'react';
import { SetupModalContext } from '../../contexts';
import { SetupModal } from '../../entities';

export function useSetupModal(): SetupModal {
    const setup = useContext(SetupModalContext);

    if (!setup) {
        throw new Error('SetupModalContext context not initialized!');
    }

    return setup;
}
